import { createUploadLink } from 'apollo-upload-client';

export const httpLink = createUploadLink({
  uri: `${`${process.env.REACT_APP_BASE_URL}/graphql` || ''}`,
  fetchOptions: {
    mode: 'cors',
  },
});
